/**
 * EDI-SIG Frontend Theme Management Module
 */
export const Theme = {
  init() {
    const savedTheme = localStorage.getItem('edi-sig-theme');
    const initialTheme = savedTheme || 'light';
    this.setTheme(initialTheme);

    $(document).on('click', '#theme-toggle-btn', (e) => {
      e.preventDefault();
      const currentTheme = localStorage.getItem('edi-sig-theme') || 'light';
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      this.setTheme(newTheme);
    });
  },

  setTheme(theme) {
    localStorage.setItem('edi-sig-theme', theme);
    const link = document.getElementById('layout-stylesheet');
    const toggleIcon = document.getElementById('theme-toggle-icon');
    
    if (theme === 'light') {
      if (link) link.setAttribute('href', 'assets/css/demo1/style.css');
      document.body.classList.remove('sidebar-dark');
      document.body.classList.add('sidebar-light', 'light-theme');
      
      if (toggleIcon) {
        toggleIcon.setAttribute('data-feather', 'moon');
        toggleIcon.setAttribute('class', 'text-muted');
      }
    } else {
      if (link) link.setAttribute('href', 'assets/css/demo2/style.css');
      document.body.classList.remove('sidebar-light', 'light-theme');
      document.body.classList.add('sidebar-dark');
      
      if (toggleIcon) {
        toggleIcon.setAttribute('data-feather', 'sun');
        toggleIcon.setAttribute('class', 'text-warning');
      }
    }
    
    if (typeof feather !== 'undefined') {
      feather.replace();
    }
  }
};
